import axios from "axios";
import { FULFILLED, PENDING, REJECTED } from "./action-type.util";

const ACTION_TYPES = {
  FETCH_GME_GSI_DETAILS: "applications/FETCH_GME_GSI_DETAILS",
  SAVE_GME_SCHOOL: "applications/SAVE_GME_SCHOOL",
  SAVE_ACTIVE_GME: "applications/SAVE_ACTIVE_GME",
  SAVE_GME_DETAIL: "applications/SAVE_GME_DETAIL",
  SAVE_GSI_GROUP: "applications/SAVE_GSI_GROUP",
  SAVE_ACTIVE_GSI: "applications/SAVE_ACTIVE_GSI",
  SAVE_GSI_DETAIL: "applications/SAVE_GSI_DETAIL",
  CLEAR_GME_GSI_ERROR: "CLEAR_GME_GSI_ERROR",
};

const initialState = {
  gmeGsiDetails: {
    SelectedGMESchools: [],
    SelectedGSIGroups: [],
    AvailableGMESchools: [],
    AvailableGSIGroups: [],
    ApplicationGMESchool: [],
    ApplicationGSIGroup: [],
    errorMessage: null,
  },
  loading: false,
};

export type ApplicationGmeGsiState = Readonly<typeof initialState>;

export default (state: ApplicationGmeGsiState = initialState, action): ApplicationGmeGsiState => {
  switch (action.type) {
    case PENDING(ACTION_TYPES.FETCH_GME_GSI_DETAILS):
    case PENDING(ACTION_TYPES.SAVE_GME_SCHOOL):
    case PENDING(ACTION_TYPES.SAVE_GME_DETAIL):
    case PENDING(ACTION_TYPES.SAVE_GSI_DETAIL):
    case PENDING(ACTION_TYPES.SAVE_GSI_GROUP):
      return {
        ...state,
        loading: true,
      };

    case FULFILLED(ACTION_TYPES.FETCH_GME_GSI_DETAILS):
      return {
        ...state,
        loading: false,
        gmeGsiDetails: {
          ...state.gmeGsiDetails,
          ...action.payload.data,
        },
      };

    case FULFILLED(ACTION_TYPES.SAVE_GME_SCHOOL):
      return {
        ...state,
        loading: false,
        gmeGsiDetails: {
          ...state.gmeGsiDetails,
          AvailableGMESchools: [
            ...state.gmeGsiDetails.AvailableGMESchools,
            { gid: action.payload.data.gid, description: action.meta.newItem },
          ],
        },
      };

    case FULFILLED(ACTION_TYPES.SAVE_GSI_GROUP):
      return {
        ...state,
        loading: false,
        gmeGsiDetails: {
          ...state.gmeGsiDetails,
          AvailableGSIGroups: [
            ...state.gmeGsiDetails.AvailableGSIGroups,
            { gid: action.payload.data.gid, description: action.meta.newItem },
          ],
        },
      };

    case FULFILLED(ACTION_TYPES.SAVE_GME_DETAIL):
    case FULFILLED(ACTION_TYPES.SAVE_GSI_DETAIL):
      return {
        ...state,
        loading: false,
      };

    case REJECTED(ACTION_TYPES.FETCH_GME_GSI_DETAILS):
    case REJECTED(ACTION_TYPES.SAVE_GME_DETAIL):
    case REJECTED(ACTION_TYPES.SAVE_GSI_DETAIL):
      return {
        ...state,
        loading: false,
      };

    case REJECTED(ACTION_TYPES.SAVE_GME_SCHOOL):
    case REJECTED(ACTION_TYPES.SAVE_GSI_GROUP):
      return {
        ...state,
        loading: false,
        gmeGsiDetails: {
          ...state.gmeGsiDetails,
          errorMessage: action.payload,
        },
      };

    case ACTION_TYPES.CLEAR_GME_GSI_ERROR:
      return {
        ...state,
        gmeGsiDetails: {
          ...state.gmeGsiDetails,
          errorMessage: null,
        },
      };

    default:
      return state;
  }
};

export { ACTION_TYPES as GME_GSI_ACTION_TYPES };

export const fetchApplicationGMEGSIDetails = (appId: string) => ({
  type: ACTION_TYPES.FETCH_GME_GSI_DETAILS,
  payload: axios.get(`applications/gmegsidetails?appId=${appId}`),
});

export const saveGMESchool = (userId: string, newItem: string) => async dispatch => {
  try {
    dispatch({ type: `PENDING(${ACTION_TYPES.SAVE_GME_SCHOOL})` });

    const response = await axios.post(`applications/gmegsidetails/gme?userId=${userId}`, JSON.stringify(newItem), {
      headers: { "Content-Type": "application/json" },
    });

    if (response.data === -1) {
      dispatch({
        type: `REJECTED(${ACTION_TYPES.SAVE_GME_SCHOOL})`,
        payload: "A school with this name already exists!",
      });
      return;
    }

    dispatch({
      type: `FULFILLED(${ACTION_TYPES.SAVE_GME_SCHOOL})`,
      payload: { data: response.data },
      meta: { newItem },
    });
  } catch (error) {}
};

export const saveActiveGMESchools = (applicationId: number, userId: number, activeItems: any[]) => async dispatch => {
  try {
    dispatch({ type: `PENDING(${ACTION_TYPES.SAVE_ACTIVE_GME})` });

    const payload = activeItems.map(item => ({
      id: item.id,
      gid: item.gid || item.id,
      description: item.description,
      applicationId,
      userId,
    }));

    await axios.post(`applications/${applicationId}/gmegsidetails/activeGME`, payload, {
      headers: { "Content-Type": "application/json" },
    });
  } catch (error) {
    dispatch({ type: `REJECTED(${ACTION_TYPES.SAVE_ACTIVE_GME})` });
  }
};

export const saveAppDetailGME = (applicationId: number, userId: number, selectedSchool) => async dispatch => {
  try {
    dispatch({ type: PENDING(ACTION_TYPES.SAVE_GME_DETAIL) });

    const payload = { ...selectedSchool, applicationId, userId };

    await axios.post(`applications/${applicationId}/gmegsidetails/appGME`, payload, {
      headers: { "Content-Type": "application/json" },
    });

    dispatch({ type: FULFILLED(ACTION_TYPES.SAVE_GME_DETAIL) });
  } catch (error) {
    dispatch({ type: REJECTED(ACTION_TYPES.SAVE_GME_DETAIL), payload: error });
  }
};

export const saveGSIGroup = (userId: string, newItem: string) => async dispatch => {
  try {
    dispatch({ type: `PENDING(${ACTION_TYPES.SAVE_GSI_GROUP})` });

    const response = await axios.post(`applications/gmegsidetails/gsi?userId=${userId}`, JSON.stringify(newItem), {
      headers: { "Content-Type": "application/json" },
    });

    if (response.data === -1) {
      dispatch({
        type: `REJECTED(${ACTION_TYPES.SAVE_GSI_GROUP})`,
        payload: "A GSI group with this name already exists!",
      });
      return;
    }

    dispatch({
      type: `FULFILLED(${ACTION_TYPES.SAVE_GSI_GROUP})`,
      payload: { data: response.data },
      meta: { newItem },
    });
  } catch (error) {}
};

export const saveActiveGSIGroups = (applicationId: number, userId: number, activeItems: any[]) => async dispatch => {
  try {
    dispatch({ type: `PENDING(${ACTION_TYPES.SAVE_ACTIVE_GSI})` });

    const payload = activeItems.map(item => ({
      id: item.id,
      gid: item.gid || item.id,
      description: item.description,
      applicationId,
      userId,
    }));

    await axios.post(`applications/${applicationId}/gmegsidetails/activeGSI`, payload, {
      headers: { "Content-Type": "application/json" },
    });
  } catch (error) {
    dispatch({ type: `REJECTED(${ACTION_TYPES.SAVE_ACTIVE_GSI})` });
  }
};
export const saveAppDetailGSI = (applicationId: number, userId: number, selectedGroup) => async dispatch => {
  try {
    dispatch({ type: PENDING(ACTION_TYPES.SAVE_GSI_DETAIL) });

    const payload = { ...selectedGroup, applicationId, userId };

    await axios.post(`applications/${applicationId}/gmegsidetails/appGSI`, payload, {
      headers: { "Content-Type": "application/json" },
    });

    dispatch({ type: FULFILLED(ACTION_TYPES.SAVE_GSI_DETAIL) });
  } catch (error) {
    dispatch({ type: REJECTED(ACTION_TYPES.SAVE_GSI_DETAIL) });
  }
};

export const clearGMEGSIError = () => ({
  type: ACTION_TYPES.CLEAR_GME_GSI_ERROR,
});
